/**
 * Форматирование даты для договора и актов: «04» февраля 2026 г.
 * @param {string} dateStr - дата в формате дд.мм.гггг или дд-мм-гггг
 * @returns {string} дата прописью с ведущим нулём у дня
 */
export function formatDateContract(dateStr) {
    if (!dateStr || typeof dateStr !== 'string') return '';
    const normalized = dateStr.replace(/-/g, '.');
    const parts = normalized.split('.');
    if (parts.length !== 3) return dateStr;
    const [dd, mm, yyyy] = parts;
    const monthIndex = parseInt(mm, 10);
    const months = [
        '', 'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
        'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
    ];
    const monthName = months[monthIndex] || mm;
    const day = String(parseInt(dd, 10)).padStart(2, '0');
    return `«${day}» ${monthName} ${yyyy} г.`;
}

/**
 * Форматирование даты для текста: 04 февраля 2026 (без кавычек и « г.»)
 * @param {string} dateStr - дата в формате дд.мм.гггг или дд-мм-гггг
 * @returns {string}
 */
export function formatDateLong(dateStr) {
    if (!dateStr || typeof dateStr !== 'string') return '';
    const normalized = dateStr.replace(/-/g, '.');
    const parts = normalized.split('.');
    if (parts.length !== 3) return dateStr;
    const [dd, mm, yyyy] = parts;
    const monthIndex = parseInt(mm, 10);
    const months = [
        '', 'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
        'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
    ];
    const monthName = months[monthIndex] || mm;
    const day = String(parseInt(dd, 10)).padStart(2, '0');
    return `${day} ${monthName} ${yyyy}`;
}
